<div class="container">
  <form [formGroup]="requisitionForm" class="requisition-preview-form">
    <!-- Keep the header outside scrollable area -->
    <div class="requisition-header" *ngIf="showHide!='hide'">
      <h1 class="requisition-title">Training Requisition Preview</h1>
      <div class="action-buttons">
        <button type="button" class="my-btn" (click)="cancelRequisition()">Cancel</button>
        &nbsp;
        <button type="button" class="my-btn" (click)="updateRequistionStatus()">Approve</button>
      </div>
    </div>

    <!-- Wrap all preview sections in scrollable content -->
    <div class="scrollable-content">
      <!-- Document Info Section -->
      <div class="form-section preview-section" #reqSection>
        <h2 class="section-title" (click)="toggleSection(reqSection)">Requisition Creation</h2>
        <div class="section-content">
          <div class="form-row">
            <div>
              <label class="form-label">Document Number</label>
              <div class="preview-value">{{ requisitionData?.docNo }}</div>
            </div>
            <div>
              <label class="form-label">Document Date</label>
              <div class="preview-value">
                {{ requisitionData?.docDate ? (requisitionData?.docDate | date:'mediumDate') : 'N/A' }}
              </div>
            </div>
            <div>
              <label class="form-label">Status</label>
              <div class="preview-value">
                <span class="status-badge">
                  {{ requisitionData?.status || 'N/A' }}
                </span>
              </div>
            </div>
          </div>
          <div class="form-row">
            <div>
              <label class="form-label">Customer Name</label>
              <div class="preview-value">{{requisitionData?.customerDetails?.name??'' }}</div>
            </div>
            <div>
              <label class="form-label">Customer Type</label>
              <div class="preview-value">{{ requisitionData?.customerDetails?.customerType || 'N/A' }}</div>
            </div>
          </div>
          <div class="form-row">
            <div>
              <label class="form-label">Contact Person</label>
              <div class="preview-value">{{ requisitionData?.customerDetails?.contactPerson?.name }}</div>
            </div>
            <div>
              <label class="form-label">Contact Number</label>
              <div class="preview-value">{{ requisitionData?.customerDetails?.contactPerson?.mobile }}</div>
            </div>
            <div>
              <label class="form-label">Email ID</label>
              <div class="preview-value">{{ requisitionData?.customerDetails?.contactPerson?.email || 'N/A' }}</div>
            </div>
          </div>

        </div>
      </div>

      <!-- Billing Details Section -->
      <div class="form-section preview-section" #billingSection>
        <h2 class="section-title" (click)="toggleSection(billingSection)">Billing Details</h2>
        <div class="section-content">
          <div class="form-row">
            <div class="full-width">
              <label class="form-label">Billing Address</label>
              <div class="preview-value address-preview">{{ billingDetailsData?.billingDetails?.billingAddress }}</div>
            </div>
          </div>
          <div class="form-row">
            <div>
              <label class="form-label">GST Number</label>
              <div class="preview-value">{{ billingDetailsData?.billingDetails?.gstNo || 'N/A' }}</div>
            </div>
            <div>
              <label class="form-label">Payment Terms</label>
              <div class="preview-value">{{ billingDetailsData?.billingDetails?.paymentTerms || 'N/A' }}</div>
            </div>
            <div>
              <label class="form-label">Estimated Amount</label>
              <div class="preview-value amount-preview">
                {{ (billingDetailsData?.billingDetails?.estimateAmount | currency:'INR':'symbol':'1.2-2') || 'N/A' }}
              </div>
            </div>
          </div>
        </div>
      </div>

      <!-- Training Schedules Section -->
      <div class="form-section preview-section" #schedulesSection>
        <h2 class="section-title" (click)="toggleSection(schedulesSection)">Training Schedules</h2>
        <div class="section-content">
          <!-- Tab Navigation -->
          <div class="schedule-tabs preview-tabs">
            <div class="tab-header">
              <button type="button" class="tab-button" *ngFor="let schedule of trainingSchedulesData; let i = index"
                [class.active]="activeTabIndex === i" (click)="setActiveTab(i)">
                {{ schedule.Title }}
              </button>
            </div>
          </div>

          <!-- Tab Content Container -->
          <div class="tab-content-container preview-tab-content">
            <!-- Loop through all schedules but show only the active one -->
            <div *ngFor="let schedule of trainingSchedulesData; let i = index"
              class="schedule-item tab-panel preview-tab-panel" [class.active]="activeTabIndex === i">

              <!-- Basic Information -->
              <div class="form-row">
                <div *ngIf="schedule.Title" class="detail-item">
                  <label class="detail-label">Title:</label>
                  <div class="training-details-display">
                    <p class="training-detail-text">{{ schedule.Title }}</p>
                  </div>
                </div>
              </div>

              <div class="form-row">
                <div *ngIf="schedule.Title" class="detail-item">
                  <label class="detail-label">Course:</label>
                  <div class="training-details-display">
                    <p class="training-detail-text">{{ schedule.Course?.Name }}</p>
                  </div>
                </div>
              </div>
              <div class="form-row">
                <div class="detail-item">
                  <div class="session-list">
                    <div *ngFor="let dateRange of schedule.DateRanges" class="session-item">
                      <div class="session-header">
                        <strong>{{ dateRange.Title || 'Training Session' }}:</strong>
                      </div>
                      <div class="session-details">
                        <span class="session-date">
                          <i class="fas fa-calendar"></i>
                          {{ formatDateRange(dateRange.StartDate, dateRange.EndDate) }}
                        </span>
                        <span class="session-time">
                          <i class="fas fa-clock"></i>
                          {{ formatTime(dateRange.StartTime) }} - {{ formatTime(dateRange.EndTime) }}
                        </span>
                      </div>
                    </div>
                  </div>
                </div>
              </div>

              <div class="form-row">
                <!-- Participants Information -->
                <div class="detail-item">
                  <label class="detail-label">Participants ({{ getTotalParticipants(schedule.Participants) }}):</label>
                  <div class="participants-display">
                    <div class="participant-chips">
                      <span *ngFor="let participant of getDisplayParticipants(schedule.Participants)"
                        class="participant-chip">
                        <i class="fas fa-user"></i>
                        {{ participant }}
                      </span>
                      <span *ngIf="getRemainingParticipantsCount(schedule.Participants) > 0" class="more-participants">
                        +{{ getRemainingParticipantsCount(schedule.Participants) }} more
                      </span>
                    </div>
                  </div>
                </div>
              </div>

              <div class="form-row">
                <!-- Training Details -->
                <div class="detail-item">
                  <label class="detail-label">Access Via Invited Email Only:</label>
                  <!-- <div class="training-details-display">
                    <p class="training-detail-text">{{ schedule.accessViaInvitedEmailOnly }}</p>
                  </div> -->
                  <div class="training-details-display">
                    <label class="switch">
                      <input type="checkbox" [checked]="schedule.AccessViaInvitedEmailOnly" disabled>
                      <span class="slider round"></span>
                    </label>
                  </div>
                </div>
              </div>

              <div class="form-row">

                <!-- Trainers Information -->
                <div class="detail-item">
                  <label class="detail-label">Assigned Trainers:</label>
                  <div class="trainers-display">
                    <span *ngFor="let trainer of schedule.Trainers" class="trainer-chip">
                      <i class="fas fa-chalkboard-teacher"></i>
                      {{ trainer.Name }}
                    </span>
                  </div>
                </div>

              </div>
              <div class="form-row">
                <!-- Training Details -->
                <div *ngIf="schedule.TrainingDetail" class="detail-item">
                  <label class="detail-label">Training Details:</label>
                  <div class="training-details-display">
                    <p class="training-detail-text">{{ schedule.TrainingDetail }}</p>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>


      <!-- Additional Information Section -->
      <div class="form-section preview-section" #additionalSection>
        <h2 class="section-title" (click)="toggleSection(additionalSection)">Additional Information</h2>
        <div class="section-content">
          <div class="form-row">
            <div class="full-width">
              <label class="form-label">Special Requirements</label>
              <div class="preview-value additional-info">{{ additionalInformationData?.specialRequirements }}</div>
            </div>
          </div>
          <div class="form-row">
            <div class="full-width">
              <label class="form-label">Final Comments</label>
              <div class="preview-value additional-info">{{ additionalInformationData?.finalComments || 'N/A' }}</div>
            </div>
          </div>
        </div>
      </div>

    </div>
  </form>
</div>